"use client"

import { useRouter } from "next/navigation"
import Icon from "@components/shared/Icon"


export function BackButton ({ iconStyle, style }) {
    const router = useRouter()
    const back = () => router.back()

	return (
		<span icon="true" onClick={back} role="button" style={style}>
			<Icon style={iconStyle}>arrow_back</Icon>
		</span>
	)
}